import * as React from 'react';
import b_ from 'b_';
import { compose, withProps } from 'recompose';
import { form, FormProps } from 'shared/utils/form';
import SubmitButton from 'shared/components/SubmitButton';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { validate } from 'shared/utils/validators';
import { routine } from './actions';
import { FormData, constraints } from './constraints';
import { IdeaToOrderFragment } from './__generated__/IdeaToOrderFragment';
import { AmountInput } from 'shared/components/AmountInput';

import './index.scss';

export interface Props {
  idea: IdeaToOrderFragment;
  min: number;
  max: number;
  initialAmount: number;
}

type Enhanced = Props & InjectedTranslateProps & FormProps<FormData, Props>;

const b = b_.with('order-submit-modal-form');

const enhance = compose<Enhanced, Props>(
  translate,
  withProps<Props, Props & { initialValues: FormData }>((props) => ({
    ...props,
    initialValues: {
      amount: props.initialAmount,
    },
  })),
  form<FormData, Props>(routine, {
    form: 'order-submit-modal',
    validate: (values, { min, max }) => validate(constraints(min, max), values),
  })
);

class OrderSubmitModal extends React.Component<Enhanced> {
  render() {
    const { t, formSubmit, idea, max, submitting, error } = this.props;

    return (
      <section className={b()}>
        <h2>{t('Invest in {{name}}', { name: idea.name })}</h2>
        <form onSubmit={formSubmit}>
          <div className={b('input')}>
            <AmountInput
              name="amount"
              currency={idea.enterAmount.currency}
              min={idea.enterAmount.value}
              max={max}
            />
          </div>
          <SubmitButton className={b('btn')} submitting={submitting} error={error}>
            {t('Invest')}
          </SubmitButton>
        </form>
      </section>
    );
  }
}

export default enhance(OrderSubmitModal);
